import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import Heading from '@atlaskit/heading/heading';
import TeamworkGraphIcon from '@atlaskit/icon-lab/core/teamwork-graph';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { token } from '@atlaskit/tokens';

const i18n = defineMessages({
	connectionsTwg: {
		id: 'byline-connections.menu.header.title-teamwork-graph-twg.do-not-translate',
		defaultMessage: 'Teamwork Graph',
		description:
			'Title shown at the top of the connections byline menu, which lists the links and references connected to the current page. "Teamwork Graph" is a product name and is intentionally not translated.',
	},
});

const styles = cssMap({
	header: {
		display: 'flex',
		width: '320px',
		paddingTop: token('space.150'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.100'),
		paddingLeft: token('space.200'),
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'flex-start',
		gap: token('space.050'),
	},
	titleRow: {
		display: 'flex',
		width: '100%',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
});

export const HEADER_HEADING_ID = 'byline-connections-heading';

export const ConnectionsByLineMenuHeader = (): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<Box xcss={styles.header}>
			<Box xcss={styles.titleRow}>
				<Inline space="space.100" alignBlock="center">
					<TeamworkGraphIcon label="" />
					<Heading id={HEADER_HEADING_ID} size="xsmall">
						{formatMessage(i18n.connectionsTwg)}
					</Heading>
				</Inline>
			</Box>
		</Box>
	);
};
